import CookiesProvider from '@web/walter-lib/cookies'
import { LocaleProvider } from '@web/walter-lib/locale'
import { SWRConfig } from 'swr'
import { BrowserRouter } from 'react-router-dom'
import { ConfigContext } from '@web/walter-lib/config'
import React from 'react'
import { ErrorBoundary } from '@sentry/react'
import { ThemeProvider } from '@web/walter-lib/theme'
import { AppImg } from '@web/walter-ui-kit'
import { useInitializeApp } from './useInitializeApp'
import { Providers } from './Providers'
import s from './s.module.css'
import { PosthogLayer } from '~contexts/PosthogLayer'
import { initSentry } from '~utils/sentry/init'
import { images } from '~constants/images'

import '@web/walter-ui-kit/themes/themes.css'
import '@web/walter-ui-kit/themes/themes.redesign.css'
import '@web/walter-ui-kit/themes/tailwind.css'
import '@web/walter-ui-kit/cssVariables/variables.css'
import '~style.css'

const SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN

if (SENTRY_DSN) {
    initSentry(SENTRY_DSN)
}

function Content() {
    const { locales, config, locale, initialTheme, onSetTheme, isLoading } = useInitializeApp()

    if (isLoading) {
        if (initialTheme) {
            return (
                <ThemeProvider main onSetTheme={onSetTheme} initialTheme={initialTheme}>
                    <div className={s.logoWrap}>
                        <div className={s.logo}>
                            <AppImg imgName={images.logoNew} />
                        </div>
                    </div>
                </ThemeProvider>
            )
        }

        return null
    }

    return (
        <ConfigContext.Provider value={config || null}>
            <LocaleProvider initialLocale={locale} initialLocales={locales}>
                <BrowserRouter>
                    <PosthogLayer>
                        <ThemeProvider main onSetTheme={onSetTheme} initialTheme={initialTheme}>
                            <Providers />
                        </ThemeProvider>
                    </PosthogLayer>
                </BrowserRouter>
            </LocaleProvider>
        </ConfigContext.Provider>
    )
}

export function App() {
    return (
        <ErrorBoundary fallback={<p>An error has occurred</p>}>
            <CookiesProvider initialCookies={document.cookie}>
                <SWRConfig
                    value={{
                        shouldRetryOnError: false,
                        revalidateOnReconnect: false,
                        revalidateOnFocus: false,
                        revalidateIfStale: false,
                    }}
                >
                    <Content />
                </SWRConfig>
            </CookiesProvider>
        </ErrorBoundary>
    )
}
